export default __webpack_public_path__ + "static/media/bl18.e4e0bdb4.png";